/** @format */

export const capitalizeFirstLetter = (str) => {
   if (str && typeof str === "string") {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
   }
   return str;
};
